import React, { useState, useContext, useEffect } from 'react';

import { Input, Button, ActionLink } from '../../atoms';
import { AuthService } from '../../../services';
import { UserContext } from '../../../context';
import { validateEmail } from '../../../utils/input.validator';
import { default as t } from '../../../utils/i18n';

import './forgot-password.scss';

function ForgotPassword({ updateStep }) {
  const { setUser } = useContext(UserContext);

  const [email, setEmail] = useState('');
  const [disableButton, setDisableButton] = useState(true);
  const [validationError, setValidationError] = useState(null);

  const loadingDefaultState = {
    buttonText: t('user.buttonText.continue'),
    buttonClass: '',
    loadingIcon: false
  };
  
  const [isLoading, setIsLoading] = useState(loadingDefaultState);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  const handleChange = e => {
    e.preventDefault();
    setValidationError(null);
    const emailPattern = /\S+@\S+\.\S+/;
    const { value } = e.target;
    if (value && emailPattern.test(value)) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
    setEmail(value);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    let errorMessage = validateEmail(email);
    if (errorMessage) {
      return setValidationError(errorMessage);
    }
   setIsLoading({
      buttonClass: 'button-checking',
      buttonText: `${t('user.buttonText.checking')}`,
      loadingIcon: true
    });
    
    try {
      const checkUserResponse = await AuthService.checkUser(email.toLowerCase());
      const forgotPasswordResponse = await AuthService.forgotPassword(email.toLowerCase());
      setUser(prevUserState => ({
        ...prevUserState,
        username: checkUserResponse.data?.data?.username,
        name: checkUserResponse.data?.data?.name,
      }));
      updateStep(2);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        setValidationError(t(`error.${dataCode}`));
      }
    }
    setIsLoading(loadingDefaultState);
   
  };

  if (!isMounted) return null;

  return (
    <div className="step1__card-container">
      <h1 className="step1__heading">{t('forgot.step1.heading')}</h1>
      <h2 className="step1__subheading">{t('forgot.step1.subheading')}</h2>
      <div className="step1__form-group">
        <form onSubmit={handleSubmit}>
          <div className="input-container">
            <Input
              labelValue={t('user.input.label.emailAddress')}
              name="email"
              fieldType="text"
              placeholder={t('user.input.placeholder.emailAddress')}
              value={email}
              handleChange={handleChange}
              errorMessage={validationError}
              actionLinkValue={t('user.link.forgotPassword')}
              actionLinkRedirect={'/forgot'}
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
            />
          </div>

          <div className="button-container">
            <Button
              type="submit"
              name="submit"
              label={isLoading.buttonText}
              className={isLoading.buttonClass}
              disabled={disableButton}
              loader={isLoading.loadingIcon}
            />
          </div>
        </form>
        <div className="step1__footer">
          <ActionLink value={`< ${t('forgot.common.backLink')}`} redirectTo="/signIn" />
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
